import { render, staticRenderFns } from "./OrderTag.vue?vue&type=template&id=e87a2d44&"
import script from "./OrderTag.vue?vue&type=script&lang=ts&"
export * from "./OrderTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports